export class MotorStatusMdl
{
    public msgKey:string;
    public Result:string;
    public StatusCode:string;
    public StatusDesc:string;
    public StatusDescAr:string;
}




// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/MotorStatusMdl.ts